import React from 'react';
import { useSelector } from 'react-redux';
import BadgeCmp from 'src/components/BadgeCmp';
import CardCmp from 'src/components/CardCmp';
import EntityChatView from 'src/components/EntityChatView';
import { RootState } from 'src/redux/store';

interface IProps {
    orderId: string | number;
    mainLoading?: boolean;
}

const MessagesWidget: React.FC<IProps> = ({ orderId, mainLoading }) => {
    const { unreadCount, isLoading } = useSelector((state: RootState) => state.orderChat);
    const hasUnread = unreadCount > 0;

    return (
        <CardCmp
            headerTitle="Messages"
            isCardContentWithoutSpacing={true}
            isCardFooterWithoutSpacing={true}
            footerParentClassName="widget-card-footer-wrap"
            childrenClassName=""
            isHeaderWithBg
            headerLeftSideContent={
                isLoading || hasUnread ? (
                    <BadgeCmp style="modern" type="orange" mainClassName={`relative ${isLoading ? 'custom-loading' : ''}`} isHidePillDot={true}>
                        {isLoading ? '0' : unreadCount}
                        {hasUnread && <div className="absolute -top-1 -right-1 w-2 h-2 bg-danger600 rounded-full" />}
                    </BadgeCmp>
                ) : null
            }
            isFooter={true}
            footerLeftSideContent={null}
        >
            <EntityChatView
                entityId={orderId}
                entityType="order"
                isActive={true}
                mainLoading={mainLoading}
                hideHeader={true}
                isFromWidget={true}
                // Sidebar preview — must not pull the caret out of the page on load. It also kept
                // the focus handler firing mark-as-read before the user had opened the thread.
                autoFocusInput={false}
                chatContainerClassName="h-[192px] max-h-[192px] min-h-[192px]"
            />
        </CardCmp>
    );
};

export default MessagesWidget;
